
import { common } from './common/zh';
import { products } from './products/zh';
import { pricing } from './pricing/zh';
import { solutions } from './solutions/zh';

export const zh = {
  ...common,
  ...products,
  ...pricing,
  ...solutions,
};
